import { render, staticRenderFns } from "./SubdomainTable.vue?vue&type=template&id=67ab2e00&"
import script from "./SubdomainTable.vue?vue&type=script&lang=js&"
export * from "./SubdomainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports